import { Injectable } from '@angular/core';
import { switchMap, map } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { flatten } from 'lodash';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BaseService {

  constructor(
  ) {}

  fetchOver100(http: HttpClient, url: string, params: any = {}, config: any = {}): Observable<any> {
    const settings = Object.assign({
      limit: null,
      // @TODO: Add more parameters as
      //   offset: 0,
      //   fromPage: 1,
    }, config);
    const queries = [];
    let page = 1;
    let totalQueriesToExecute = 0;
    let results = [];

    if (params.params) {
      const httpParams = params.params;
      params.params = httpParams.keys().reduce((object: any, key: string) => {
        object[key] = httpParams.get(key);
        return object;
      }, {});

      delete params.params.per_page;
      delete params.params.page;
    }

    return http.get(url + '?per_page=100&page=' + page, params)
      .pipe(
        switchMap((response: any) => {
          const total = (settings.limit && settings.limit < response.meta.total) ? settings.limit : response.meta.total;
          totalQueriesToExecute = Math.ceil(total / response.meta.per_page);
          results = response.items;

          for (let i = 0; i <= totalQueriesToExecute; i++) {
            queries.push(
              http.get(url + '?per_page=100&page=' + (++page), params)
              .pipe(
                map((loopResponse: any) => {
                  return loopResponse.items;
                })
              )
            );
          }

          return forkJoin(queries)
            .pipe(
              map((responses) => {
                results = results.concat(flatten(responses));
                results = results.slice(0, settings.limit || 10000);
                return results;
              })
            );
        })
      );
  }

  hydrate(Obj, payload) {
    if (payload && payload['items'] && payload['items'].length) {
      payload['items'] = payload['items'].map(item => new Obj(item));
      return payload;
    } else if (payload && Array.isArray(payload)) {
      payload = payload.map(item => new Obj(item));
      return payload;
    } else {
      return new Obj(payload);
    }
  }

  dateRange(datePipe: any, apiParams: any, field: string, start: string, end: string) {
    let startDate = '',
        endDate = '';

    if (start) {
      startDate = datePipe.transform(start, 'yyyy-MM-ddT00:00:00');
    }

    if (end) {
      endDate = datePipe.transform(end, 'yyyy-MM-ddT23:59:59');
    }

    const dateFilter = `${startDate}--${endDate}`;

    if (startDate || endDate) {
      apiParams = apiParams.append(field, dateFilter);
    }

    return apiParams;
  }
}
